var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('module1'),_c('module2'),_c('module3'),_c('module4'),_c('module5'),_c('module6',{ref:"home6"}),_c('module7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }